import { render, staticRenderFns } from "./orderEvaluate.vue?vue&type=template&id=23427ed9&scoped=true"
import script from "./orderEvaluate.vue?vue&type=script&lang=js"
export * from "./orderEvaluate.vue?vue&type=script&lang=js"
import style0 from "./orderEvaluate.vue?vue&type=style&index=0&id=23427ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23427ed9",
  null
  
)

export default component.exports